module.exports = __webpack_public_path__ + "img/zhujianghui.2c90b973.jpg";